import { render, staticRenderFns } from "./DeliveryStatusUI.vue?vue&type=template&id=c4c756c8&scoped=true&"
import script from "./DeliveryStatusUI.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusUI.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatusUI.vue?vue&type=style&index=0&id=c4c756c8&lang=sass&scoped=true&"
import style1 from "./DeliveryStatusUI.vue?vue&type=style&index=1&id=c4c756c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c756c8",
  null
  
)

export default component.exports